// The services that have a Sync page (Strava, Garmin Connect, Zwift, Wahoo): their names and marks.

export type SyncService = 'strava' | 'garmin' | 'zwift' | 'wahoo'

export type ServiceInfo = {
  name: string
  /** The badge colour behind the mark. */
  color: string
  /** A Font Awesome icon for the mark, or else `mask`: a one-colour image shown in white. */
  icon?: string
  mask?: string
  /** The service's own setup guide on the Xert site. */
  guide?: string
}

export const SERVICES: Record<SyncService, ServiceInfo> = {
  strava: { name: 'Strava', color: '#fc4c02', icon: 'fa-brands fa-strava' },
  garmin: { name: 'Garmin Connect', color: '#007cc3', mask: '/assets/global/img/providers/garmin.svg' },
  zwift: { name: 'Zwift', color: '#fc6719', mask: '/assets/global/img/providers/zwift.svg', guide: 'https://baronbiosys.com/xert-zwift/' },
  wahoo: { name: 'Wahoo', color: '#111827', mask: '/assets/global/img/providers/wahoo-elemnt.png', guide: 'https://baronbiosys.com/xert-wahoo/' },
}
